// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__2aAVE","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__1SUus"};